// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Brand_wrapper__QuNFe","item":"Brand_item__lg0_E","scroll-left":"Brand_scroll-left__NTwJt"};